import {computed, ComputedRef, Ref, ref} from "vue";

import {getInsertionTarget} from "@km/mixins/SelObInsertionPointFinder";
import {EventVerteiler} from "@k/global/eventVerteiler";
import {SelObTypes} from "@k/js/SelObTypes";
import {CONTROLLER_EVENTNAMES, SELOBEVENTNAMES} from "@k/global/GlobalEventnames";
import {TabNames} from "@km/data/tabs";
import {SelectableObject} from "@k/js/selectableObjects";
import {LOGOMODULE_POSSIBLE_STATES} from "@km/components/logo/ModuleLogoAnimationStates";
import {filterOutClones} from "@km/js/SelObCloneFilter";
import {trackPageview} from "@k/js/globalsObject";
import {useModuleLogoOpenStateStore} from "@km/store/frontendstate/useModuleLogoOpenState";
import {Store} from "vuex";
import {AnimationWaitingForTargetFactory, KeyFrameTargetValues} from "@km/animations/animationFactory";
import {useModuleColorOpenStateStore} from "@km/store/frontendstate/useModuleColorOpenState";

export default class ModuleLogoFunctions {

    public static logoObjectToEdit:Ref<SelectableObject|null>;
    public static currentColor:Ref;
    public static logoLibrary: ComputedRef;
    public static logoList: ComputedRef;
    public static currentPalettenCluster: ComputedRef;
    public static currentColorValue: ComputedRef;
    private static openStatusStore: ReturnType<typeof useModuleLogoOpenStateStore>;



    public static init(store) {
        ModuleLogoFunctions.setRefs();
        ModuleLogoFunctions.setComputed(store);
        ModuleLogoFunctions.openStatusStore = useModuleLogoOpenStateStore();
    }

    private static setRefs() {
        const self =ModuleLogoFunctions;
        self.logoObjectToEdit = ref(null);
        self.currentColor = ref(null);
    }

    private static setComputed(store) {

        const self = ModuleLogoFunctions;
        self.logoLibrary = computed(() => store.getters.getLogoPool);
        self.logoList =  computed(() => filterOutClones(store.getters.getLogoObjects)) as ComputedRef<SelectableObject[]>;
        self.currentPalettenCluster = computed(() => store.getters.getPalettenCluster("CM5 Bedruckbar"));
        self.currentColorValue = computed(()=>self.currentColor.value === null ? -1 : self.currentColor.value.colorIntValue);
    }

    public static broadcastLogoColorChange(id, colorCode, colorHexValue) {
        EventVerteiler.broadcast(
            CONTROLLER_EVENTNAMES.CHANGESELOBWITHHISTORY,
            {id, changedProperties: {colors: {colorCode,colorHexValue}}}
        );
    }

    public static broadcastInsertLogoEvent(filename, {part, position}) {
        trackPageview("logohinzugefuegt.htm");
        EventVerteiler.broadcast("createLogoObjectFromFrontEndEvent",{filename, part, position});
    }


    public static setLogoObjectToEditFromParameter(data){
        if (!data) {
            ModuleLogoFunctions.logoObjectToEdit.value = null;
        } else {
            ModuleLogoFunctions.logoObjectToEdit.value = (([SelObTypes.LOGO, SelObTypes.CHROMOLOGO, SelObTypes.STOCKLOGO].indexOf(data.type) > -1) ? data : null);
        }
    }
    public static setLogoObjectToEdit(obj){
        ModuleLogoFunctions.logoObjectToEdit.value=obj;
    }

    public static setCurrentLogoColor(colorObject){
        const self = ModuleLogoFunctions;
        self.currentColor.value.colorIntValue = parseInt(colorObject.RGBHex, 16);
        self.broadcastLogoColorChange((self.logoObjectToEdit.value as SelectableObject).id, self.currentColor.value.colorCode, colorObject.RGBHex)
    }

    public selObDeSelectedEventHandler(store){
        ModuleLogoFunctions.setLogoObjectToEdit(null);
        store.getters.LOGOTABisOpen ? ModuleLogoFunctions.openStatusStore.setCurrentState(LOGOMODULE_POSSIBLE_STATES.logoverwaltung) :
            ModuleLogoFunctions.openStatusStore.setCurrentState(LOGOMODULE_POSSIBLE_STATES.closed);
    }

    public selObSelectedEventHandler(data, store){
        ModuleLogoFunctions.setLogoObjectToEditFromParameter(data);
        if(ModuleLogoFunctions.logoObjectToEdit.value !== null) {
            ModuleLogoFunctions.openStatusStore.setCurrentState(LOGOMODULE_POSSIBLE_STATES.edit);
        }
        if(ModuleLogoFunctions.logoObjectToEdit.value !== null && !store.getters.LOGOTABisOpen) {
            store.commit("SET_TAB_OPEN", TabNames.LOGO);
        }
    }

    public static insertLogoOnShirt(logoPoolEntry) {
        ModuleLogoFunctions.broadcastInsertLogoEvent(logoPoolEntry.filename, getInsertionTarget());
    }

    public colorPickerClicked(color, store) {
        ModuleLogoFunctions.openStatusStore.setCurrentState(LOGOMODULE_POSSIBLE_STATES.color);
        ModuleLogoFunctions.currentColor.value = color;
    }

    static selObSelectedFromRahmenEventHandler(id:string, store) {
        const selOb = store.getters.getSelOb(id);
        if(selOb === null) {
            return;
        }
        ModuleLogoFunctions.setLogoObjectToEditFromParameter(selOb);
        if(ModuleLogoFunctions.logoObjectToEdit.value !== null) {
            ModuleLogoFunctions.openStatusStore.setCurrentState(LOGOMODULE_POSSIBLE_STATES.edit);
        }
    }

    public static deselectLogoifSelected() {
        if(ModuleLogoFunctions.logoObjectToEdit.value !== null){
            EventVerteiler.broadcast(SELOBEVENTNAMES.SELECTION_CLEARED);
        }
    }
}

export function getLogoModuleColorShadeAnimation() {
    const openStatusStore = useModuleLogoOpenStateStore();
    const animation = AnimationWaitingForTargetFactory.getFadeInOutAnimation(".km__modules__logo--color--shade");
    const keyframes = new KeyFrameTargetValues({targetValue: 9999, opacity: 1}, {targetValue: -9999, opacity: 0});
    return {animation, keyframes, getterForWatch: () => openStatusStore.getColorShadeState}
}

export function getLogoModuleColorMainAnimation() {
    const animation = AnimationWaitingForTargetFactory.getLeftRightAnimationpercentWithOpacityAnimation('.km__modules__color--shadegroup-selection');
    const keyframes = new KeyFrameTargetValues({targetValue: -100, opacity: 1}, {targetValue: 100, opacity: 0});
    const openStatusStore = useModuleColorOpenStateStore();
    return {animation, keyframes, getterForWatch: () => openStatusStore.getShadeGroupState}
}
